/* eslint-disable react/sort-comp */
import * as React from 'react';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { FormError, FormWarning } from '@estee/elc-form';

const StyledFormError = styled(FormError)`
  border: none;
  background: none;
  padding: 0;
  text-align: left;
`;

const StyledFormWarning = styled(FormWarning)`
  padding: 0;
  border: none;
  background: none;
  text-align: left;
`;

export interface IErrorMessagesProps {
  messages?: string [];
  className?: string;
  notification?: boolean;
}

@observer
class ErrorMessages extends React.Component<IErrorMessagesProps> {
  public render(): JSX.Element {
    const {
      props: {
        className,
        notification,
      },
    } = this;

    const nodes = this.formattedErrors;
    if (nodes.length) {
      // this is a hack because we should be able to set any
      // react nodes as content
      const children = nodes as React.ReactNode as string;
      if (notification) {
        return (
          <div data-error-messages className={className}>
            <StyledFormWarning className="elc-notification-message">
              {children}
            </StyledFormWarning>
          </div>
        );
      }
      return (
        <div data-error-messages className={className}>
          <StyledFormError>
            {children}
          </StyledFormError>
        </div>
      );
    }

    return null;
  }

  @computed
  private get formattedErrors(): React.ReactNode [] {
    const {
      props: {
        messages,
      },
    } = this;

    const errors = messages || [];

    return errors.map(this.formatError);
  }

  private formatError(error: string, idx: number): React.ReactNode {
    const parts = error && error.split('\n').reduce<React.ReactNode []>(
      (acc, part, index) => {
        const suffix = `${part}-${index}`;
        acc.push((
          <div
            key={`err-${suffix}`}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: part,
            }}
          />
        ));

        return acc;
      },
      [],
    );

    const suffix = `${error}-${idx}`;

    return (
      <div key={`err-${suffix}`}>
        {parts}
      </div>
    );
  }
}

export default ErrorMessages;
